export default "__VITE_ASSET__DqmjcHpX__"